import * as React from 'react';
import { ShipIcon } from '../../components/Icons/ShipIcon';
import { config } from '../../config';
import { acqa, mapBackground, white } from '../../consts/variables';
import { __ } from '../../helpers/TranslationService';
import { IShipLivePositionPageReducer } from '../../interfaces/IShipLivePosition';
import { ArrowRightIcon } from '../Icons/ArrowRightIcon';
import { Link } from '../Link';
import { ShipPositionInfo } from './ShipPositionInfo';

const style: Record<string, React.CSSProperties> = {
    wrapper: {
        minHeight: '167px',
        color: white,
        position: 'relative',
    },
    mapBackground: {
        backgroundColor: mapBackground,
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
    },
    portInfo: {
        paddingLeft: 5,
        fontSize: 15,
    },
    anchorIcon: {
        fill: white,
        verticalAlign: 'middle',
    },
    currentPort: {
        fontSize: 20,
    },
    positionText: {
        display: 'flex',
        padding: '0px 10px',
    },
    linkWrapper: {
        display: 'flex',
        width: '100%',
        marginTop: 15,
        justifyContent: 'center',
        alignItems: 'center',
    },
    arrow: {
        fill: acqa,
        height: 15,
    },
    link: {
        color: acqa,
        fontSize: 15,
    },
};

interface IProps {
    shipTitle?: string;
    showLivePosition?: boolean;
    url?: string;
    showMapOnly: boolean;
    position: IShipLivePositionPageReducer;
}

const bgImage: any = {
    background: `url("${config.images}/common/worldmap.png") no-repeat center center`,
    backgroundSize: 'cover',
};

const PositionPageLink = ({ url, shipTitle }) => {
    return (
        <div style={style.linkWrapper}>
            <Link href={url} style={style.link}>
                {__('%s position (ship page)', 'dreamlines', shipTitle)}
            </Link>
            <ArrowRightIcon style={style.arrow} />
        </div>
    );
};
const getCurrentPosition = (currentPort: string): string => {
    if (currentPort && currentPort.length > 0) {
        return currentPort;
    }
    return __('is moving (ship page)', 'dreamlines');
};

export const ShipPosition = (props: IProps) => (
    <div className="shipPositionCard">
        {props.position && props.position.shipPosition ? (
            <div style={{ ...style.wrapper, ...bgImage }}>
                <div style={style.mapBackground}>
                    <div style={style.positionText}>
                        <ShipIcon style={style.anchorIcon} width={42} height={42} />
                        <div style={style.portInfo}>
                            <div style={style.currentPort}>
                                {getCurrentPosition(props.position.shipPosition.currentPort)}
                            </div>
                            {props.position.shipPosition.nextPort && (
                                <div>{`${__('end harbor', 'dreamlines')}: ${
                                    props.position.shipPosition.nextPort
                                }`}</div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        ) : null}
        {props.showMapOnly && <ShipPositionInfo position={props.position.shipPosition} />}
    </div>
);
